import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { BIO_ICONS, type BioIconKey } from "@/lib/bioIcons";

interface BioIconPickerProps {
  value: string;
  onChange: (value: BioIconKey) => void;
  /** id do rótulo visível (o trigger é quem recebe foco). */
  "aria-labelledby"?: string;
}

export function BioIconPicker({
  value,
  onChange,
  "aria-labelledby": labelledBy,
}: BioIconPickerProps) {
  return (
    <Select value={value} onValueChange={(v) => onChange(v as BioIconKey)}>
      <SelectTrigger aria-labelledby={labelledBy}>
        <SelectValue placeholder="Escolha um ícone" />
      </SelectTrigger>
      <SelectContent>
        {(Object.keys(BIO_ICONS) as BioIconKey[]).map((key) => {
          const { label, Icon } = BIO_ICONS[key];
          return (
            <SelectItem key={key} value={key}>
              <div className="flex items-center gap-2">
                <Icon className="h-4 w-4" />
                <span>{label}</span>
              </div>
            </SelectItem>
          );
        })}
      </SelectContent>
    </Select>
  );
}
